import { render, staticRenderFns } from "./TaxonomyActionMassDelete.vue?vue&type=template&id=bb865380&"
import script from "./TaxonomyActionMassDelete.vue?vue&type=script&lang=ts&"
export * from "./TaxonomyActionMassDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports